import * as React from 'react';

// API
import apibridge from '../apibridge';

// PACKAGES
import { Link } from 'react-router-dom';

// COMPONENTS
import OrganisationLogo from './OrganisationLogo';
import Button from './Button';

// REDUX
import { useAppSelector, useAppDispatch } from '../store';
import UserSlice from '../store/slices/User';

// ICONS
import { ReactComponent as BurgerMenuIcon } from '../assets/svg/burger.svg';
import { ReactComponent as BurgerMenuCloseIcon } from '../assets/svg/menu-close.svg';
import { ReactComponent as ArrowUpIcon } from '../assets/svg/arrow-up.svg';
import { ReactComponent as ArrowDownIcon } from '../assets/svg/arrow-down.svg';
import { ReactComponent as ArrowRightIcon } from '../assets/svg/arrow-right.svg';
import { ReactComponent as LinkIcon } from '../assets/svg/link.svg';
import FallbackImage from '../assets/svg/image-fallback-square.svg';

interface organisationMenuTypes {
	isBurgerMenuShow: boolean;
	setIsBurgerMenuShow: React.Dispatch<React.SetStateAction<boolean>>;
}
import { AccountUserUserProfile as OrganisationItemType } from '../api/models';

const OrganisationMenu: React.FC<organisationMenuTypes> = ({ isBurgerMenuShow, setIsBurgerMenuShow }) => {
	const dispatch = useAppDispatch();

	const user = useAppSelector((state) => state.user);

	// State for display which organisation is active, and which ones are not
	const [activeOrganisation, setActiveOrganisation] = React.useState<OrganisationItemType | null>(null);
	const [inActiveOrganisation, setInActiveOrganisation] = React.useState<OrganisationItemType[]>([]);

	// State to hide and show menu
	const [isOrganisationMenuShow, setIsOrganisationMenuShow] = React.useState<boolean>(false);

	// Hide and Show Burger Menu
	const burgerMenuHandler = () => {
		if (isOrganisationMenuShow) {
			setIsOrganisationMenuShow(false);
		}
		setIsBurgerMenuShow(!isBurgerMenuShow);
	};

	// Hide and Show organisation Menu
	const organisationMenuHandler = () => {
		if (isBurgerMenuShow) {
			setIsBurgerMenuShow(false);
		}
		setIsOrganisationMenuShow(!isOrganisationMenuShow);
	};

	// Fuctions to Reset Active Organisation when click on an inactive organisations on menu
	const organisationItemClickHandler = async (profileId?: string) => {
		setIsOrganisationMenuShow(!isOrganisationMenuShow);

		const response = await apibridge.doSwitchOrganisation(profileId);

		if (response.isError) {
			console.log(response.validationErrors.map((error: any) => 'Error: ' + (error.name + ' - ' + error.reason)));
		} else {
			dispatch(UserSlice.actions.forceUpdate({}));
		}
	};

	const [mounted, setIsMounted] = React.useState<boolean>(false);

	// Getting all organisations and filter which organisation is active, and which ones are not.
	React.useEffect(() => {
		if (user.profiles && user.profiles.length) {
			user.profiles.map((profile) => {
				if (profile.id === user.activeProfileId) {
					setActiveOrganisation(profile);
				} else {
					setInActiveOrganisation((prevState) => [...prevState, profile]);
				}
			});
		} else {
			setIsOrganisationMenuShow(true);
		}
		setIsMounted(true);
	}, []);

	// Set up fall back image
	const [imageSrc, setImageSrc] = React.useState<string | undefined>(
		activeOrganisation ? activeOrganisation.image : FallbackImage
	);

	React.useEffect(() => {
		if (mounted) {
			setImageSrc((activeOrganisation && activeOrganisation.image) || FallbackImage);
		}
	}, [activeOrganisation && activeOrganisation.image]);

	return (
		<nav className="organisation-menu">
			{activeOrganisation !== null ? (
				<>
					<div className="organisation-menu-main">
						<div className="organisation-menu-main-left">
							<div className="organisation-logo-wrapper">
								<img
									className="organisation-logo-main"
									src={imageSrc}
									alt="organisation logo"
									onError={() => {
										if (imageSrc !== FallbackImage) {
											setImageSrc(FallbackImage);
										}
									}}
								/>
							</div>

							<span className="organisation-name">{activeOrganisation.name}</span>

							<span className="organisation-role">{activeOrganisation.roleName}</span>
						</div>

						<div className="organisation-menu-main-right">
							<Button className="btn-icon" onClick={organisationMenuHandler}>
								{isOrganisationMenuShow ? <ArrowUpIcon /> : <ArrowDownIcon />}
							</Button>

							<Button className="btn-icon burger-menu" onClick={burgerMenuHandler}>
								{isBurgerMenuShow ? <BurgerMenuCloseIcon /> : <BurgerMenuIcon />}
							</Button>
						</div>
					</div>

					<div className={`organisation-menu-sub ${isOrganisationMenuShow ? 'show' : ''}`}>
						<h2 className="section-info">Switch, join or register an organisation</h2>

						{inActiveOrganisation &&
							inActiveOrganisation.map((organisation) => {
								return (
									<Link
										className="organisation-list-item"
										key={organisation.id}
										onClick={() => organisationItemClickHandler(organisation.id)}
										to="/dashboard"
									>
										<div className="item-detail">
											<OrganisationLogo src={organisation.image} extraClass="mr-12" alt="organisation logo" size={40} />
											<div className="item-info">
												<span className="item-name">{organisation.name}</span>

												<span className="item-role">{organisation.roleName}</span>
											</div>
										</div>

										<Button className="item-icon btn-icon">
											<ArrowRightIcon />
										</Button>
									</Link>
								);
							})}

						<section className="link-group">
							{/* {user && user.canJoinOrganisation && ( */}
							<Link className="btn btn-primary" to="/find-organisation">
								<LinkIcon className="link-icon" />
								Join another organisation
							</Link>
							{/* )} */}

							{/* {user && user.canRegisterOrganisation && ( */}
							<Link className="btn btn-primary" to="/plans">
								<LinkIcon className="link-icon" />
								Register a new organisation
							</Link>
							{/* )} */}
						</section>
					</div>
				</>
			) : null}
		</nav>
	);
};

export default OrganisationMenu;
